<input
  id="textSearch"
  autocomplete="off"
  type="text"
  class="form-control"
  [formControl]="control"
  [placeholder]="placeholder"
  />

@if (!hasValue && !isLoading) {
  <i class="fas fa-search fa-fw"></i>
}

@if (hasValue && !isLoading) {
  <i
    class="fas fa-times fa-fw"
    (click)="clear()"
  ></i>
}

@if (isLoading) {
  <i class="fa fa-spinner fa-pulse nile-blue-color"></i>
}
